import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', () => {

    const sustainabilityPage = document.querySelector('.page-template-template-sustainability')
    if (sustainabilityPage !== null) {

        const mainHeroSlide = new Splide('.js-sustainability-slider', {
            type: 'fade',
            pagination: false,
            drag: false,
            gap: "2rem",
            fixedHeight: "98rem",
            breakpoints: {
                1023: {
                    gap: "0",
                    height: "30rem",
                    fixedHeight: "30rem",
                    fixedWidth: "100%",
                    width: "100%",
                },
            },
        })

        mainHeroSlide.mount()
    }
})
